import { createApiClient } from '@shigo-ui/api-client';

import type { ShigoApiConfig } from './shigo-api-client';
import { runtimeNetworkBrandDetailsSchema } from './networkBranding';

export async function loadPublicNetworkBrandDetails(config: ShigoApiConfig, signal: AbortSignal) {
  try {
    return await createApiClient({ baseUrl: config.apiBaseUrl }).request({
      path: `/api/public/networks/${encodeURIComponent(config.networkId)}/brand-details`,
      schema: runtimeNetworkBrandDetailsSchema,
      init: { signal, credentials: 'omit' },
    });
  } catch (error) {
    if (signal.aborted) throw error;
    // Branding must not block access to authentication when the public endpoint is unavailable.
    return null;
  }
}
